/*
 * Note re: explicit numbering:  THESE ENUMS ARE STORED IN LOCALSTORAGE as user settings.
 * If their values change, the storage code must accommodate "v1" settings.
 */

export type KeySelectionOptions = {
  isPreferMajor: boolean;
  autoPin: NotePinningAutomationSettings;
};

// Visual Hints / indications are perhaps a separate setting.
// (1) blink suggestions in manual mode
// (2) toast notification (ruled out xyz? in auto mode)? Seems noisy.

export enum DumbAutoSetting {
  Manual = 0,
  Auto = 1,
}

export enum SmartAutoSetting {
  Manual = 0,
  /** Apply contextual intelligence, e.g. "this isn't a blues scale, so no flat 5". */
  ContextualAuto = 1,
  /** Ignore this particular interval all the time. */
  AlwaysAuto = 2,
}

export type NotePinningAutomationSettings = {
  dim2ndIgnore: DumbAutoSetting;
  wrong3rdIgnore: DumbAutoSetting;
  flat5Ignore: SmartAutoSetting;
  wrong6thIgnore: SmartAutoSetting;
  wrong7thIgnore: SmartAutoSetting;
};

export function buildAutoPinSettingDefaults() {
  return {
    dim2ndIgnore: DumbAutoSetting.Auto,
    wrong3rdIgnore: DumbAutoSetting.Auto,
    flat5Ignore: SmartAutoSetting.ContextualAuto,
    wrong6thIgnore: SmartAutoSetting.ContextualAuto,
    wrong7thIgnore: SmartAutoSetting.AlwaysAuto,
  };
}

export function buildAutoPinSettingsDisableAll() {
  return {
    dim2ndIgnore: DumbAutoSetting.Manual,
    wrong3rdIgnore: DumbAutoSetting.Manual,
    flat5Ignore: SmartAutoSetting.Manual,
    wrong6thIgnore: SmartAutoSetting.Manual,
    wrong7thIgnore: SmartAutoSetting.Manual,
  };
}
